module.exports = __webpack_public_path__ + "static/media/04_thumbnail.f7236d2a.jpg";